export const isSpacecraftEngine = (part) => part.type === 'engine';
export const isSpacecraftFuelContainer = (part) => part.type === 'fuel-container';
//# sourceMappingURL=spacecraft.js.map